// Address configuration
export const addressConfig = {
  // Set to true for demo/development, false for production with real APIs
  useMockData: false,
  
  // API endpoints for job addresses (base URL comes from API_URL env variable)
  endpoints: {
    addresses: '/user-job-addresses',
    createAddress: '/user-job-addresses',
    updateAddress: (id: number) => `/user-job-addresses/${id}`,
    deleteAddress: (id: number) => `/user-job-addresses/${id}`,
    setDefaultAddress: (id: number) => `/user-job-addresses/${id}/set-default`,
    getAddress: (id: number) => `/user-job-addresses/${id}`,
  }
}; 